ReactBacon = require 'react-bacon'
React      = require 'react'
R          = require 'ramda'
{ Icon } = require 'react-fa'
cx = require 'classnames'
uuid = require 'uuid'
PropTypes = require 'prop-types'
createReactClass = require 'create-react-class'
uiStore = require 'stores/ui'
cartsStore = require 'stores/carts'
ReactBacon = require 'react-bacon'
listStore = require 'stores/lists'
{ BaconMixin } = ReactBacon
userStore = require 'stores/user'
{ withRouter } = require 'react-router-dom'
{ Nav, NavItem, Label, NavLink, Button} = require 'reactstrap'

import { LiveListsSidebar } from '../../models/list-live'

filterTabs = (stream, type) ->
  stream
    .map R.filter R.propEq('type', type)

renderList = (title, list, itemRender, addUrl, expanded, version = 0) ->
  expandedClass = cx "text-justify", 'hidden': !expanded
  showAdd = cx 'hidden': !addUrl
  <div>
    <div className={expandedClass}>
      <a className={showAdd} href={addUrl} className="btn btn-default btn-sm btn-block" role="button">
        <Icon name="search-plus" /> Create List
      </a>
      <div className="list-title"><span>{ title }</span></div>
    </div>
    <Nav key={version} pills vertical>
      { R.map itemRender, list }
    </Nav>
  </div>

iconForTabType = (type) ->
  switch type
    when 'lists' then 'list'
    when 'rdsLists' then 'list-alt'
    when 'reviews' then 'comments'
    when 'carts' then 'shopping-cart'
    when 'orders' then 'shopping-cart'


Sidebar = createReactClass
  displayName: 'Sidebar'

  propTypes:
    expanded: PropTypes.bool.isRequired

  mixins: [ ReactBacon.BaconMixin ]

  getInitialState: ->
    lists: []
    reviews: []
    rdsLists: []
    tabs: []
    carts: []
    orders: []
    current: null
    cart: null # don't remove as current cart needs at least one listener
    version: 0
    loggedIn: false
    removeList: false


  componentWillMount: ->
    @plug filterTabs(uiStore.active, "lists"), 'lists'
    @plug filterTabs(uiStore.active, "orders"), 'orders'
    @plug filterTabs(uiStore.active, "reviews"), 'reviews'
    @plug filterTabs(uiStore.active, "carts"), 'carts'
    @plug userStore.loggedIn, 'loggedIn'
    @plug uiStore.active, "tabs"

    @plug uiStore.current, 'current'
    @plug cartsStore.current, 'cart'

    @plug uiStore.version, 'version'

  onRemoveLists: ->
    @setState removeList : not (@state.removeList)

  onCreateCart: ->
    newCartUUID = uuid()
    cartsStore.createCart newCartUUID
    @props.history.push "/carts/#{newCartUUID}"

  render: ->
    if @state.loggedIn
      <div>
        <LiveListsSidebar expanded={@props.expanded} />
        { @renderLists() }
        { @renderOrders() }
        { @renderPendingOrders() }
        { @renderReviews() }
        { @renderRemoveLists() }
        { @renderInvoices() }
      </div>
    else
      null
      
  renderLists: ->
    renderList "Orders", @state.lists, @renderTab, "#/lists/new", @props.expanded, @state.version

  renderOrders: ->
    if @state.orders.length > 0
      renderList "Pinned Orders", @state.orders, @renderTab, null, @props.expanded, @state.version

  renderReviews: ->
    if @state.reviews.length > 0
      <Nav pills vertical>
        { R.map @renderTab, @state.reviews }
      </Nav>

  renderPendingOrders: ->
    return null unless userStore.hasRole 'config'
    expandedClass = cx "text-justify", 'hidden': !@props.expanded
    orderListClass = cx "list-title", "hidden": @state.carts.length == 0

    if @props.expanded
      # <div>
        # <div className={expandedClass}>
        #   <a href="#/carts/new" className="btn btn-default btn-sm btn-block" role="button">
        #     <Icon name="search-plus" /> Create New Order
        #   </a>
        #   <div className={ orderListClass }><span>Pending Orders</span></div>
        # </div>
        # <Nav pills vertical>
        #   { R.map @renderTab, @state.carts }
        # </Nav>
      # </div>
    else
      <ul className="nav nav-pills nav-stacked">
        <li role="presentation">
          <a role="button" href="#/carts">
            <Label>
              <Icon name="shopping-cart" />
            </Label>
          </a>
        </li>
      </ul>
  
  renderRemoveLists: ->
    if @state.lists.length > 0 and @state.removeList
      btnText = "Done"
    else
      btnText = "Remove List"
    <div>
      <div className= "text-justify">
        <Button onClick = {@onRemoveLists} className="btn btn-default btn-sm btn-block" role="button">
            {btnText}
        </Button>
      </div>
    </div>

  renderInvoices: ->
    if !userStore.hasRole 'restaurant_staff'
      <div>
        <a href="#/statements" className="nav-link">Statements</a>
      </div>

  renderTab: (tab) ->
    activeKey = R.path(['current', 'id'], @props)
    <ListButton key={tab.id} tab={tab} activeKey={activeKey} expanded={@props.expanded} remove={@state.removeList}/>

SoundService = require 'components/sound'

initials = R.pipe(R.split(/\s+/), R.map(R.nth(0)), R.join(""))

ListButton = createReactClass
  displayName: 'TabButton'

  mixins: [ReactBacon.BaconMixin]

  propTypes:
    tab: PropTypes.object.isRequired
    expanded: PropTypes.bool.isRequired
    activeKey: PropTypes.object

  getInitialState: ->
    loading: false
    activity: false
    changes: null
    remove: false
    totalOrders: 0
    pageNumber: 0

  componentWillMount: ->
    @plug @props.tab.loading, 'loading' if @props.tab.loading
    @plug @props.tab.activity, 'activity' if @props.tab.activity
    @plug @props.tab.totalOrders, 'totalOrders' if @props.tab.totalOrders
    @plug @props.tab.pageNumber, 'pageNumber' if @props.tab.pageNumber

  onRemoveList: ->
    if !@props.tab.locked
      listStore.removeList @props.tab.id
      uiStore.switchToFirst()
    else
      alert "This tab is locked! Please edit the tab settings to unlock it and then try again!"

  render: ->
    if @props.expanded
      <NavItem key={@props.tab.id} active={@props.activeKey} >
        <div style={wrap: "no", overflowX: "hidden"}>
          <span className="pull-right">{@renderInfo()}</span>
          <NavLink href="#/#{@props.tab.type}/#{@props.tab.id}">
            <Icon name={iconForTabType(@props.tab.type)}/>
            {' '}{@props.tab.name}
            <SoundService soundStream={@props.tab.noise} />
          </NavLink>
        </div>
      </NavItem>

    else
      labelStyle = if @state.activity then "danger" else "default"
      <span>
        <Label color={labelStyle}>{ initials(@props.tab.name) }<br/>{@renderInfoText()}</Label>
        <SoundService soundStream={@props.tab.noise} />
      </span>

  renderInfoText: ->
    if @state.loading
      "??"
    else if @state.totalOrders
      @state.totalOrders

  renderInfo: ->
    if @props.remove
      <Button onClick = {@onRemoveList}><Icon key="removeList" name="close" className="pull-right" /></Button>
    else
      if @state.loading
        <Icon key="loading" name="spinner" spin={true} fixedWidth={true}  className="pull-right" />
      else if @state.totalOrders != null and @state.totalOrders != 0 and @props.tab.getSearchAPIVersion() == 'v5'
        labelStyle = if @state.activity then "danger" else "default"
        <Label key="total" color={labelStyle} className="pull-right">
          {@state.totalOrders}
        </Label>
      else if @state.activity
        labelStyle = if @state.activity then "danger" else "hidden"
        <Label key="active" color={labelStyle} className="pull-right">*</Label>
      else null


module.exports = withRouter(Sidebar)
